import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const CreditCardRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment-mean--credit-card']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
